import * as React from 'react';
import * as styles from './Service.css';
import classNames from 'classnames';
import { Header2, InlineText1, InlineText2 } from '@cian/ui-kit';

export interface IServiceProps {
  title: string;
  subTitle: string | null;
  dataName: string;
  bgColor: 'white' | 'gradient';
  checked: boolean;
  icon: React.ReactNode;
  description: string | string[];
  footer: React.ReactNode;
  onClick(): void;
}

export const Service = ({
  title,
  subTitle,
  dataName,
  bgColor,
  checked,
  icon,
  description,
  footer,
  onClick,
}: IServiceProps) => {
  let items;

  if (Array.isArray(description)) {
    items = description.map((item, index) => (
      <div key={index} className={styles['description_item']}>
        <InlineText2>· {item}</InlineText2>
      </div>
    ));
  } else {
    items = <InlineText2>{description}</InlineText2>;
  }

  return (
    <div
      onClick={onClick}
      data-name={dataName}
      className={classNames(styles['card'], styles[bgColor], checked && styles['checked'])}
    >
      {icon && <div className={styles['icon']}>{icon}</div>}

      <Header2>{title}</Header2>

      {subTitle && <InlineText1>{subTitle}</InlineText1>}

      <div className={classNames(styles['description'], !subTitle && styles['without_subtitle'])}>{items}</div>

      <div className={styles['footer']}>{footer}</div>
    </div>
  );
};
